import { useRef } from "react";
import { useA11yNestedNavigation } from "../../../a11y";
import { UseA11yNestedNavigationArguments } from "../../../a11y/hooks/use-a11y-nested-navigation/types";

export const useOptionsA11y = ({
  maxIndex,
}: Pick<UseA11yNestedNavigationArguments, "maxIndex">) => {
  const optionsRef = useRef<HTMLUListElement>(null);

  const { handleEnter, handleAfterBlur, ...restProps } =
    useA11yNestedNavigation({
      maxIndex,
      hasFocusableChildren: true,
    });

  const scrollTop = () => optionsRef.current?.scrollTo({ top: 0 });

  const handleEnterKeyDown = () => {
    scrollTop();
    handleEnter();
  };

  const resetFocus = () => {
    scrollTop();
    handleAfterBlur();
  };

  return {
    optionsRef,
    resetFocus,
    handleEnterKeyDown,
    ...restProps,
  };
};
